import React from "react";
import { Box, useTheme, useMediaQuery } from '@mui/material';
import VillaImage from "../components/IndividualVilla/VillaImage";
import VillaDetails from "../components/IndividualVilla/VillaDetails";
import DetailsOverview from "../components/IndividualVilla/DetailsOverview";
import { useState, useEffect } from "react";
import { investorApi, vendorApi, api } from "../api/api";
import CryptoJS from "crypto-js";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams,useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateReferrerId } from "../redux/reducers/Reducer";
import PropertyDocument from "../components/PropertyDetalis/PropertyDocument";
import RecentPropertiesList from "../components/RecentProperties/RecentPropertiesList";
import Loader from "../components/common/Loader";
import LoginModal from "../components/common/LoginModal";
import ScreenContainer from "../components/common/screencontainer";
const SECRET_KEY = "yourSecretKey";
const IndividualVillaScreen = () => {
  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { slug } = useParams();
const [searchParams] = useSearchParams();

const propertyIdFromSlug = slug?.split("-").pop();
const referralCode = searchParams.get("ref");


  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTabletOrLaptop = useMediaQuery(theme.breakpoints.down('md'));

  const encryptedpropertyId = searchParams.get('propertyId');
  const encryptedUserId = searchParams.get('userId');
  const decryptData = (ciphertext) => {
    try {
      const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    catch (err) {
      return null;
    }
  }
  const propertyId = encryptedpropertyId ? decryptData(encryptedpropertyId) : null;
  const ReffererId = encryptedUserId ? decryptData(encryptedUserId) : null;
  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const query = decodeURIComponent(location.search.slice(1));

  let property_code = null;
  let reffer_code = null;

  if (query) {
    const parts = query.split('/');
    if (parts.length === 2) {
      property_code = parts[0];
      reffer_code = parts[1];
    } else if (parts.length === 1) {
      property_code = parts[0];
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchDetails = async () => {
      try {
        // 1. Get propertyId and ReffererId from referral codes
        // const { data } = await api.getPropertyId(
        //   property_code || null,
        //   reffer_code || null
        // );
        // const propertyId = data.propertyId;
        // const ReffererId = data.userId;
        // console.log(data);
        // if (!propertyId) return;
        // if (ReffererId) {
        //   dispatch(updateReferrerId({ ReffererId }));
        // }

        // if (
        //   isAuthenticated &&
        //   userId &&
        //   propertyId &&
        //   ReffererId &&
        //   userId !== parseInt(ReffererId)
        // ) {
        //   const fd = new FormData();
        //   fd.append("userId", userId);
        //   fd.append("refererId", ReffererId);
        //   fd.append("propertyId", propertyId);

        //   await vendorApi.addProjectUserMapping(fd);
        // }


        // 4. Fetch property details
        const response = await investorApi.getIndependentHouseById(propertyIdFromSlug);

        if (response.status === 200) {
          let villa = response.data;
          // Belt-and-suspenders: detail endpoint sometimes returns MarketPrice as "₹3.2 Cr".
          // getPropertyDetailsById returns the raw numeric Approved marketupdate value.
          try {
            const numeric = await investorApi.getPropertyDetails(propertyIdFromSlug);
            if (numeric.status === 200 && numeric.data?.[0]) {
              const detail = numeric.data[0];
              villa = Array.isArray(villa) ? [...villa] : villa;
              if (villa[0]) {
                villa[0] = {
                  ...villa[0],
                  MarketPrice: detail.MarketPrice ?? villa[0].MarketPrice,
                  OriginalPropertyValue:
                    detail.OriginalPropertyValue ??
                    detail.MarketPrice ??
                    villa[0].OriginalPropertyValue,
                  TotalPrice:
                    detail.MarketPrice ??
                    villa[0].TotalPrice ??
                    villa[0].MarketPrice,
                };
              }
            }
          } catch (_) {
            // Keep villa response as-is if enrichment fails
          }
          setPropertyData(villa);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [isAuthenticated, propertyIdFromSlug, referralCode, userId, dispatch]);



  return (


    <ScreenContainer>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: isTabletOrLaptop ? 'column' : 'row',
              overflow: 'hidden',
              padding: isTabletOrLaptop ? 1 : 2,
              boxSizing: 'border-box',
            }}
          >
            {/* Left - Images */}
            <Box
              sx={{
                width: isTabletOrLaptop ? '100%' : '60%',
                pr: isTabletOrLaptop ? 0 : 2,
                mb: isTabletOrLaptop ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  overflow: 'hidden',
                }}
              >
                <VillaImage propertyId={parseInt(propertyData[0]?.Pid)} propertyType={parseInt(propertyData[0]?.PropertyType)} property_refferal_code={propertyData[0]?.refferal_code} />
              </Box>
            </Box>

            {/* Right - Details */}
            <Box
              sx={{
                width: isTabletOrLaptop ? '100%' : '40%',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  border: '1px solid',
                  borderColor: 'divider',
                  overflowY: 'auto',
                }}
              >
                {propertyData && propertyData.length > 0 && (
                  <VillaDetails propertyData={propertyData} />
                )}
              </Box>
            </Box>
          </Box>

          {propertyData && propertyData.length > 0 && (
            <DetailsOverview propertyData={propertyData} />
          )}
          <Box sx={{ marginTop: "20px", textAlign: "start" }}>
            {propertyData[0]?.Status !== 'sale Initiated' &&
              propertyData[0]?.Status !== 'Sold' && (
                <RecentPropertiesList
                  userId={userId}
                  type={propertyData[0]?.PropertyType}
                  propertyId={propertyData[0]?.Pid}
                />
              )}
          </Box>
          {propertyData[0]?.Status === 'sale Initiated' && (
            <PropertyDocument
              data={propertyData[0]?.Pid}
              userId={userId}
              type={propertyData[0]?.PropertyType}
            />
          )}
        </>
      )}
    </ScreenContainer>


  );

};
export default IndividualVillaScreen;

